import type { Translator } from "~/i18n";

export function workflowMatchPhrase(
  kind: "all" | "contact" | "keyword" | string,
  value: string,
  t: Translator,
): string {
  if (kind === "contact") {
    return t("workflows.match.fromContact", {
      value: value || t("workflows.match.aContact"),
    });
  }
  if (kind === "keyword") {
    return t("workflows.match.containing", { value });
  }
  return t("workflows.match.anyMessage");
}
